import { Route, redirect } from "@tanstack/react-router";
import { rootRoute } from "../root";

export const projectsXRiskRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "/projects/xrisk",
  beforeLoad: () => {
    throw redirect({ to: "/" });
  },
});
